import * as React from "react";
import type { SVGProps } from "react";
const SvgDiscountStar03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m8.4 15.6 7.2-7.2m-6.646.55-.014-.015m6.125 6.188-.014-.014m-3.552-11.47L9.575 2.572a.817.817 0 0 0-1.146.405l-.907 2.066a.84.84 0 0 1-.64.498l-2.157.318c-.474.07-.794.541-.7 1.03l.432 2.228a.89.89 0 0 1-.237.795l-1.566 1.58a.893.893 0 0 0 .015 1.261l1.604 1.538a.89.89 0 0 1 .256.789l-.377 2.238c-.082.491.249.954.724 1.011l2.164.261a.83.83 0 0 1 .652.48l.957 2.042c.21.449.739.62 1.156.375l1.898-1.116a.8.8 0 0 1 .798-.01l1.924 1.065a.817.817 0 0 0 1.146-.405l.907-2.066a.84.84 0 0 1 .64-.498l2.157-.318c.474-.07.794-.541.7-1.03l-.432-2.228a.89.89 0 0 1 .238-.795l1.566-1.58a.893.893 0 0 0-.016-1.261l-1.604-1.538a.89.89 0 0 1-.256-.789l.377-2.238c.082-.491-.249-.954-.724-1.011l-2.164-.261a.83.83 0 0 1-.652-.48l-.957-2.042a.816.816 0 0 0-1.156-.375l-1.897 1.116a.8.8 0 0 1-.799.01Z"
    />
  </svg>
);
export default SvgDiscountStar03;
